export type TCALC_SIP_RESULT = {
  investedAmount: number;
  estimatedReturns: number;
  totalValue: number;
};

export interface ISTEP_UP_SIP_FORMULA {
  monthlyInvestment: number;
  annualStepUp: number;
  expectedReturnRate: number;
  timePeriod: number;
}

export const STEP_UP_SIP_FORMULA = ({
  monthlyInvestment,
  annualStepUp,
  expectedReturnRate,
  timePeriod,
}: ISTEP_UP_SIP_FORMULA): TCALC_SIP_RESULT => {
  monthlyInvestment = Number(monthlyInvestment);
  annualStepUp = Number(annualStepUp);
  timePeriod = Number(timePeriod);
  expectedReturnRate = Number(expectedReturnRate);

  if (
    !monthlyInvestment ||
    !timePeriod ||
    !expectedReturnRate ||
    monthlyInvestment < 0 ||
    annualStepUp < 0 ||
    expectedReturnRate < 0 ||
    timePeriod < 0
  ) {
    return {
      investedAmount: 0,
      estimatedReturns: 0,
      totalValue: 0,
    };
  }
  const monthlyInterestRate = expectedReturnRate / 100 / 12;
  const totalMonths = timePeriod * 12;
  let totalInvestedAmount = 0;
  let totalWealth = 0;
  let currentSipAmount = monthlyInvestment;

  for (let month = 1; month <= totalMonths; month++) {
    const monthsRemaining = totalMonths - month + 1; // +1 because investment is at the end of the month
    totalWealth +=
      currentSipAmount * Math.pow(1 + monthlyInterestRate, monthsRemaining);
    totalInvestedAmount += currentSipAmount;

    // Increase SIP amount annually
    if (month % 12 === 0) {
      currentSipAmount += (currentSipAmount * annualStepUp) / 100;
    }
  }

  const wealthGained = totalWealth - totalInvestedAmount;

  return {
    investedAmount: Math.round(totalInvestedAmount),
    estimatedReturns: Math.round(wealthGained),
    totalValue: Math.round(totalWealth),
  };
};
